import api from './api';

export interface AiReport {
  id: number;
  clientId: number;
  initiatedByUserId: number;
  reportType: string;
  periodFrom: string;
  periodTo: string;
  locale: string;
  sections: string[] | null;
  customPrompt: string | null;
  context: string;
  prompt: string;
  response: string | null;
  status: 'pending' | 'completed' | 'failed';
  errorMessage: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface AiReportsListParams {
  limit?: number;
  offset?: number;
  clientId?: number;
  initiatedByUserId?: number;
  reportType?: string;
  dateFrom?: string;
  dateTo?: string;
}

export interface AiReportsListResponse {
  success: boolean;
  data: AiReport[];
  meta: {
    total: number;
    limit: number;
    offset: number;
  };
}

export const adminAiReportsService = {
  getReports: async (params: AiReportsListParams): Promise<AiReportsListResponse> => {
    const queryParams = new URLSearchParams();
    if (params.limit !== undefined) queryParams.append('limit', params.limit.toString());
    if (params.offset !== undefined) queryParams.append('offset', params.offset.toString());
    if (params.clientId) queryParams.append('clientId', params.clientId.toString());
    if (params.initiatedByUserId) queryParams.append('initiatedByUserId', params.initiatedByUserId.toString());
    if (params.reportType) queryParams.append('reportType', params.reportType);
    if (params.dateFrom) queryParams.append('dateFrom', params.dateFrom);
    if (params.dateTo) queryParams.append('dateTo', params.dateTo);

    const response = await api.get(`/ai/reports-admin?${queryParams.toString()}`);
    return response.data;
  },

  getReport: async (id: number): Promise<{ success: boolean; data: AiReport }> => {
    const response = await api.get(`/ai/reports/${id}`);
    return response.data;
  },

  downloadPdf: async (id: number): Promise<void> => {
    const response = await api.get(`/ai/reports/${id}/pdf`, {
      responseType: 'blob',
    });
    const url = window.URL.createObjectURL(response.data);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `ai-report-${id}.pdf`);
    document.body.appendChild(link);
    link.click();
    link.parentNode?.removeChild(link);
    window.URL.revokeObjectURL(url);
  },
};
